import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import modules from './modules'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

let default_state = {
    csrf: null,
    taxonomies: {
        data: [],
        meta: {
            fetched: false,
            include: 'options'
        }
    },
    vehicle_years: {
        data: [],
        meta: {
            fetched: false,
            include: ''
        }
    },
    vehicle_makes: {
        data: [],
        meta: {
            fetched: false,
            include: 'vehicleModels.vehicleTrims'
        }
    },
    vehicle_models: {
        data: [],
        meta: {
            fetched: false,
            include: 'vehicleTrims'
        }
    },
    vehicle_trims: {
        data: [],
        meta: {
            fetched: false,
            include: ''
        }
    }
};

export default new Vuex.Store({
    strict: debug,
    state: {
        ...default_state,
        ...window.App.state,
    },
    mutations,
    actions,
    getters,
    modules,
})
